/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { getAllGeos, getAllEnvTypes } from '../../services/systemSpecs';
import { getAllEnvTypesAction, getAllGeoAction } from './systemSpecActionCreator';
import { SNACKBAR_ALERT_DEFAULT_PROPS } from '../../shared/constants';
import { setSnackBarDisplay } from '../snackBar/snackBarActionCreator';
import { showErrorAction, clearErrorAction } from "../error/errorActionCreator";
import { hideLoaderAction, showLoaderAction } from "../loader/loaderActionCreator";

export const getGeos = async (dispatch: Function) => {
  let geos: any = [];
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const geoResponse = await getAllGeos();
    if (geoResponse) {
      geos = geoResponse;
      dispatch(getAllGeoAction(geos, geos.length > 0 ? false : true));
    }
    dispatch(hideLoaderAction());
  } catch (error) {
    const errorMessage = {
      message: 'Error in fetching data: ' + error
    };
    geos = [];
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in fetching data: ' + error,
        severity: 'error',
      })
    );
  }
};

export const getEnvTypesList = async (dispatch: Function) => {
  let envTypes: any = [];
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const envTypesResponse = await getAllEnvTypes();
    if (envTypesResponse) {
      envTypes = envTypesResponse.data[0]?.allowedRealmTypes || [];
      dispatch(getAllEnvTypesAction(envTypes, envTypes.length > 0 ? false : true));
    }
    dispatch(hideLoaderAction());
  } catch (error) {
    const errorMessage = {
      message: 'Error in fetching data: ' + error
    };
    envTypes = [];
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in fetching data: ' + error,
        severity: 'error',
      })
    );
  }
};

export const resetEnvTypes = async (dispatch: Function) => {
  dispatch(getAllEnvTypesAction([], true));
};